import { EventsName } from '@space-events/constants'
import type { FreeSignUpProps } from '@space-events/freesignup/types'

const freeSignUpEventDispatch = ({ productId, sectionId }: FreeSignUpProps) => {
  window.dispatchEvent(
    new CustomEvent(EventsName.FREE_SIGNUP, { detail: { productId, sectionId } })
  )
}

const freeSignUpEventListener = (listener: (event: Event) => void) => {
  window.addEventListener(EventsName.FREE_SIGNUP, listener)

  return () => {
    window.removeEventListener(EventsName.FREE_SIGNUP, listener)
  }
}

export { freeSignUpEventDispatch, freeSignUpEventListener }
